import { Buttons } from "@/ui/Buttons";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { ParallaxHexagon } from "@/ui/ParallaxHexagon";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import bg_3 from "./bg_3.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "py-5 py-md-6",
  title,
  description,
  items,
  image,
  buttons,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <div className={cn(className, classes.OurValues)} data-bs-theme={theme}>
      <ParallaxBackground anim="y2n:x0:z1" image={bg_1} className={classes.bg_1} />
      <ParallaxBackground anim="y1:x1:z0" image={bg_2} className={classes.bg_2} />
      <ParallaxBackground anim="y2:x0:z0" image={bg_3} floating={false} className={classes.bg_3} />
      <Container fluid="md">
        <Row>
          <Col xs={12} md={6} className="position-relative">
            <ParallaxHexagon translateY={[0, -20]} className={classes.img}>
              <EditableImage path="image_1" src={image} size="496x425" alt="" />
            </ParallaxHexagon>
          </Col>
          <Col xs={12} md={6} className="text-center text-md-start">
            <EditableText path="title" tag="h2" className="mb-3">
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </EditableText>
            <Row className="py-4">
              {items.map(({ icon, title, description }, idx) => (
                <Col key={idx} xs={12} md={6}>
                  <div className={classes.card}>
                    <div className="hexagon-alt bg-blue mb-3 mx-auto mx-md-0">
                      <EditableImage path={`item_${idx}_image`} src={icon} alt="" />
                    </div>
                    <EditableText path={`item_${idx}_title`} tag="h5" className="mb-3">
                      <span dangerouslySetInnerHTML={{ __html: title }} />
                    </EditableText>
                    <EditableHtml path={`item_${idx}_description`}>
                      <div dangerouslySetInnerHTML={{ __html: description }} />
                    </EditableHtml>
                  </div>
                </Col>
              ))}
            </Row>
            <EditableHtml path="description">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </EditableHtml>
            <Buttons buttons={buttons} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
